/* eslint-disable complexity */
/* eslint-disable class-methods-use-this */
/* eslint-disable max-lines */
/* eslint-disable max-statements */
import { ApiModelState } from '../apiModelState';
import { UiQueries } from '../Queries/UiQueries';
import { UiViewModelState } from '../UiState';
import { ApiWrappers } from './apiWrapper';
import { buildViewModelCommand } from './buildViewModelCommand';
import { cancelEditCommand } from './cancelEditCommand';
import { changeJustificationReasonCommand } from './changeJustificationReasonCommand';
import { changeModeCommand } from './changeModeCommand';
import { changeRevisionCodeCommand } from './changeRevisionCodeCommand';
import { changeValueCommand } from './changeValueCommand';
import { changeWeekCommand } from './changeWeekCommand';
import { changeWorkCenterFilterCommand } from './changeWorkCenterFilterCommand';
import { initializeScreenCommand } from './initializeScreenCommand';

// Commands the ui can perform
// https://martinfowler.com/bliki/CQRS.html
export class UiCommands {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    protected uiState: UiViewModelState,
    protected uiQueries: UiQueries,
    protected setUiStateTriggerReRender: (uiState: UiViewModelState) => void, // eslint-disable-next-line no-empty-function
    protected apis: ApiWrappers, // eslint-disable-next-line no-empty-function
    protected apiModelState: ApiModelState,
    protected setApiModelState: (apiModelState: ApiModelState) => void // eslint-disable-next-line no-empty-function
  ) {}

  public initializeScreen = initializeScreenCommand;

  public changeMode = changeModeCommand;

  public changeRevisionCode = changeRevisionCodeCommand;

  public buildViewModel = buildViewModelCommand;

  public changeWeek = changeWeekCommand;

  public changeValue = changeValueCommand;

  public cancelEdit = cancelEditCommand;

  public changeWorkCenterFilter = changeWorkCenterFilterCommand;

  public changeJustificationReason = changeJustificationReasonCommand;
}
